import React, { MouseEventHandler, useEffect, useState } from "react";
import {
  DefaultDroppedPinListProps,
  IDroppedPinListProps,
} from "./AdminPanel.types";
import AdminStyles from "./AdminPanel.styles";
import MockOutages from "../../api/mock/data/outages";
import { OutageViewModel } from "../../api/generated/models";
import { Col, Container, ListGroup, Row, Spinner } from "react-bootstrap";
import { ClickEvent } from "../../shared/types/event.types";
import {
  setSelectedOutageAdminMode,
  setShowAdminModal,
} from "../../state-management/slices/global/global.slice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../state-management/store";
import { RootState } from "../../state-management/root-reducer";
import PAGINATION from "../pagination/Pagination.component";
import { FeatureLayerService } from "../map/FeatureLayer.service";
import { BaseMapService } from "../map/BaseMap.service";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";

const renderListItems = (
  data: OutageViewModel[],
  dispatch: AppDispatch,
  featureLayerService: FeatureLayerService
): React.ReactNode => {
  return data.map((outage: OutageViewModel) => {
    return (
      <AdminStyles.DroppedPinListItem
        action
        className="dropped-pin-list-item"
        key={`${outage.outageId}-${outage.reportedDateTime}`}
        onClick={(event: ClickEvent): void => {
          featureLayerService.centerMapToLocation(outage);
          dispatch(setSelectedOutageAdminMode({ selectedOutage: outage }));
          dispatch(setShowAdminModal({ show: true }));
        }}
      >
        <Container className="detail-container" fluid>
          <Row>
            <Col xs={3}>Outage Id:</Col>
            <Col>{outage.outageId}</Col>
          </Row>
          <Row>
            <Col xs={3}>Address:</Col>
            <Col>
              {`${outage.location?.address}, ${outage.location?.city}, MI`}
            </Col>
          </Row>
        </Container>
      </AdminStyles.DroppedPinListItem>
    );
  });
};

const DROPPED_PIN_LIST: React.FC<IDroppedPinListProps> = (
  props: IDroppedPinListProps
) => {
  const dispatch = useDispatch();
  const sendDataToGTM = useGTMDispatch();

  const baseMapService = BaseMapService.getInstance(dispatch, sendDataToGTM);
  const featureLayerService = baseMapService.getFeatureLayerService();

  // App state
  const { adminOutages } = useSelector((state: RootState) => state.outages);
  const { isLoading, outageCollection, pagination } = adminOutages;
  const { currentPage, totalCount, pageSize } = pagination;

  return (
    <AdminStyles.DroppedPinListContainer className="dropped-pin-list-container">
      <h1>{props.title}</h1>

      {isLoading && (
        <div className="spinner-container">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      {!isLoading && outageCollection && outageCollection.length && (
        <div className="list-wrapper">
          <PAGINATION
            data={outageCollection}
            currentPage={currentPage}
            totalCount={totalCount}
          />
          <ListGroup variant="flush">
            {renderListItems(outageCollection, dispatch, featureLayerService)}
          </ListGroup>
          <PAGINATION
            data={outageCollection}
            currentPage={currentPage}
            totalCount={totalCount}
          />
        </div>
      )}

      {!isLoading && (!outageCollection || !outageCollection?.length) && (
        <AdminStyles.NoResultsContainer className="no-results-container">
          There are currently no outages to reconcile.
        </AdminStyles.NoResultsContainer>
      )}
    </AdminStyles.DroppedPinListContainer>
  );
};

DROPPED_PIN_LIST.defaultProps = DefaultDroppedPinListProps;
export default DROPPED_PIN_LIST;
